import useIvw from 'app/services/ivw/useIvw';

const Ivw = props => {
  useIvw(props.partner);
  return null;
};

export default Ivw;
